var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.678,
    height: 19.678,
    viewBox: "0 0 19.678 19.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-information-circle",
    "data-name": "Icon ionic-ios-information-circle",
    d: "M13.214,3.375a9.839,9.839,0,1,0,9.839,9.839A9.837,9.837,0,0,0,13.214,3.375Zm.9,14.38H12.306V10.939h1.807Zm-.9-7.559a.944.944,0,1,1,.979-.946A.948.948,0,0,1,13.209,10.2Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#962cc6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.13e2868085e4e6f91fc5b524280e6082.svg";
export { ForwardRef as ReactComponent };